import {
  ErrorItem
} from "./chunk-KHJY7Z5R.mjs";

// src/views/Errors/ErrorsList/ErrorsList.tsx
import { Flex } from "@chakra-ui/react";
import { Fragment, jsx } from "react/jsx-runtime";
var ErrorsList = ({ fileRejections, getErrorMessage }) => {
  const genericErrors = fileRejections.filter((item) => item.errors.some((error) => error.code === "too-many-files"));
  const specificErrors = fileRejections.filter((item) => !genericErrors.includes(item));
  const genericErrorsPresent = genericErrors.length > 0;
  const specificErrorsPresent = specificErrors.length > 0;
  if (genericErrorsPresent) {
    const genericMessage = getErrorMessage(genericErrors[0].errors[0].code);
    return /* @__PURE__ */ jsx(ErrorItem, {
      genericMessage
    });
  }
  if (specificErrorsPresent) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: specificErrors.map(({ file, errors }) => /* @__PURE__ */ jsx(Flex, {
        direction: "column",
        justify: "center",
        align: "center",
        gap: 1,
        w: "100%",
        children: errors.map((error) => /* @__PURE__ */ jsx(ErrorItem, {
          fileName: file.name,
          message: getErrorMessage(error.code)
        }, error.code))
      }, file.name))
    });
  }
  return null;
};

export {
  ErrorsList
};
